module.exports = __webpack_public_path__ + "img/03.450fc18b.png";